export const CONTENT_SEPARATOR = '|';

export const PLAN_DETAILS_PLAN_PERIOD_BENEFIT = 'No lock-in contracts, leave anytime';

export const BLACK_FRIDAY = {
  startDate: new Date('2024-11-20T00:00:00'),
  endDate: new Date('2024-12-04T00:00:00'),
};

export enum PLAN_DETAILS_RATE_TYPE {
  Fixed = 'Fixed',
  Flexible = 'Flexible',
}

export enum PLAN_DETAILS_PLAN_PERIOD {
  Ongoing = 'Ongoing',
  Months12 = '12 months',
  Months24 = '24 months',
}

export enum PLAN_DETAILS_BILLING_TYPE {
  Email = 'Email',
  EmailOrPost = 'Email or post',
}

export enum PLAN_DETAILS_EXIT_FEES {
  None = 'None',
}
